import styled from 'styled-components';
import { PropsWithAs, StyledGeneric } from './StyledGeneric';

/* Constants */
export const fontFamilies = {
  bold: "'Avenir Black', 'Arial Black', sans-serif;",
  light: "'Avenir Light', 'Arial', sans-serif",
  regular: "'Avenir', 'Arial', sans-serif;",
};

/* Helpers */
export const setFontForNodeAndDescendants = (fontType: keyof (typeof fontFamilies)) => `
  font-family: ${fontFamilies[fontType]};
  & * {
    font-family: ${fontFamilies[fontType]};
  }
`;

/* Components */
export const FontDiv = styled.div`
  ${setFontForNodeAndDescendants('regular')}
`;

export const BoldFontDiv = styled.div`
  ${setFontForNodeAndDescendants('bold')}
`;

export const LightFontDiv = styled.div`
  ${setFontForNodeAndDescendants('light')}
`;

export const Font = (props: PropsWithAs) => {
  const { as, ...propsWithoutAs } = props;
  return StyledGeneric(FontDiv, as, propsWithoutAs);
};

export const BoldFont = (props: PropsWithAs) => {
  const { as, ...propsWithoutAs } = props;
  return StyledGeneric(BoldFontDiv, as, propsWithoutAs);
};

export const LightFont = (props: PropsWithAs) => {
  const { as, ...propsWithoutAs } = props;
  return StyledGeneric(LightFontDiv, as, propsWithoutAs);
};
